export class InvalidParametersError extends Error {
    constructor(message) {
        super(message);
        this.name = 'InvalidParametersError';
    }
}
export class AgencyGatewayError extends Error {
    constructor(message) {
        super(message);
        this.name = 'AgencyGatewayError';
    }
}
